import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_2 = { class: "bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center space-x-4" }
const _hoisted_5 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_6 = { class: "flex items-center space-x-2" }
const _hoisted_7 = { class: "p-6 border-t border-gray-200" }
const _hoisted_8 = { class: "grid grid-cols-6 gap-3" }

import { computed } from 'vue'
import type { GammeComplete } from '@/types'

interface Props {
  gamme: GammeComplete
}

interface Emits {
  (e: 'edit', gamme: GammeComplete): void
  (e: 'delete', gamme: GammeComplete): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GammeCard',
  props: {
    gamme: {}
  },
  emits: ["edit", "delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// Extraire les colonnes de tailles
const sizeColumns = computed(() => {
  return [
    props.gamme.d1_FR,
    props.gamme.d2_FR,
    props.gamme.d3_FR,
    props.gamme.d4_FR,
    props.gamme.d5_FR,
    props.gamme.d6_FR,
    props.gamme.d7_FR,
    props.gamme.d8_FR,
    props.gamme.d9_FR,
    props.gamme.d10_FR,
    props.gamme.d11_FR,
    props.gamme.d12_FR,
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("div", { class: "w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" }, [
              _createElementVNode("i", { class: "fas fa-tag text-blue-600" })
            ])
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.gamme.titre || 'Sans titre'), 1),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Gamme de tailles", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit', _ctx.gamme))),
            class: "inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors",
            title: "Modifier la gamme"
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-edit mr-2" }, null, -1),
            _createTextVNode(" Modifier ")
          ])),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', _ctx.gamme))),
            class: "inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors",
            title: "Supprimer la gamme"
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1),
            _createTextVNode(" Supprimer ")
          ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
        _createElementVNode("h4", { class: "text-md font-medium text-gray-900" }, "Tailles disponibles"),
        _createElementVNode("div", { class: "text-sm text-gray-500" }, " Colonnes d1 à d12 ")
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizeColumns.value, (size, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "text-center"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["px-2 py-1 rounded-md text-sm font-medium", size ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-500'])
            }, _toDisplayString(size || '-'), 3)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})